/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringCreditDto } from '../../models/backend-monitoring-credit-dto';

export interface MonitoringScenariosCreditsList$Params {
  scenario_id: number;
}

export function monitoringScenariosCreditsList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosCreditsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringCreditDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosCreditsList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringCreditDto>>;
    }),
  );
}

monitoringScenariosCreditsList.PATH = '/api/monitoring/scenarios/{scenario_id}/credits/';
